import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Alert, Button, Snackbar } from '@mui/material';

import { clearNotificationAction, selectNotification } from 'rdx/notifications';

const Notifications = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const notification = useSelector(selectNotification);

  const handleClose = useCallback(() => {
    dispatch(clearNotificationAction());
  }, [dispatch]);

  const message = notification
    ? notification.message ?? intl.formatMessage({ id: notification.intlId })
    : '';

  const closeButtonText = notification
    ? notification.closeButtonText ??
      intl.formatMessage({
        id: notification.closeButtonIntlId || 'components.Notifications.clear',
      })
    : '';

  return (
    <Snackbar
      action={
        <Button color="primary" size="small" onClick={handleClose}>
          {closeButtonText}
        </Button>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={Boolean(notification)}
      onClose={handleClose}
      message={message}
      // Use \n in the message to break lines
      sx={{
        '& .MuiSnackbarContent-message': {
          whiteSpace: 'pre-wrap',
          width: '100%',
        },
      }}
    >
      {notification?.severity ? <Alert severity={notification.severity}>{message}</Alert> : null}
    </Snackbar>
  );
};

export default Notifications;
